export default __webpack_public_path__ + "static/media/Denis.d277c7e5.png";